import React, { useEffect, useRef } from 'react';
import { createPreviewHtml } from '../utils/html';

interface HtmlPreviewProps {
  content: string;
}

const HtmlPreview: React.FC<HtmlPreviewProps> = ({ content }) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  
  useEffect(() => {
    if (iframeRef.current) {
      // Create safe HTML content
      const previewHtml = createPreviewHtml(content);
      
      // Write content to iframe
      const iframeDocument = iframeRef.current.contentDocument;
      if (iframeDocument) {
        iframeDocument.open();
        iframeDocument.write(previewHtml);
        iframeDocument.close();
      }
    }
  }, [content]);
  
  return (
    <div className="preview-container">
      <div className="bg-gray-100 p-2 border-b border-gray-300 flex justify-between items-center">
        <span className="font-medium text-sm">HTML Preview</span>
        <button 
          className="text-xs bg-gray-200 hover:bg-gray-300 px-2 py-1 rounded"
          onClick={() => {
            // Open preview in new window
            const previewWindow = window.open('', '_blank');
            if (previewWindow) {
              previewWindow.document.write(createPreviewHtml(content));
              previewWindow.document.close();
            }
          }}
        >
          Open in New Window
        </button>
      </div>
      <iframe 
        ref={iframeRef}
        title="HTML Preview"
        className="preview-frame"
        sandbox="allow-same-origin allow-scripts"
      />
    </div>
  );
};

export default HtmlPreview; 